import { useRef } from "react";
import { useLocationData } from "../../../providers/geolocation";
import MapView, { MapViewHandle } from "../Map";

interface MapContainerProps {
  variant?: "sidebar" | "overlay";
  onClose?: () => void;
}

export const MapContainer = ({ variant = "sidebar", onClose }: MapContainerProps) => {
  const { location, mapBig, setMapBig } = useLocationData();

  const mapRef = useRef<MapViewHandle>(null);

  const isOverlay = variant === "overlay";

  const toggleMap = () => {
    setMapBig(!mapBig);
    if (mapRef.current) {
      mapRef.current.resize();
    }
  };

  return (
    <div
      className={`card-mapa d-flex align-items-center ${
        isOverlay ? "card-mapa--overlay" : "mb-5"
      }`}
    >
      <div className="map-toolbar">
        {isOverlay ? (
          <button
            type="button"
            onClick={onClose}
            className="btn btn-light shadow-sm"
            aria-label="Fechar mapa"
          >
            <i className="las la-times me-2" aria-hidden="true"></i>
            Fechar
          </button>
        ) : (
          <button
            type="button"
            onClick={toggleMap}
            className="btn btn-light shadow-sm"
            aria-pressed={mapBig}
          >
            <i
              className={`las ${mapBig ? "la-compress-arrows-alt" : "la-expand-arrows-alt"} me-2`}
              aria-hidden="true"
            ></i>
            {mapBig ? "Reduzir mapa" : "Ampliar mapa"}
          </button>
        )}
      </div>

      <MapView ref={mapRef} style={{ width: "100%", height: "100%" }} location={location} />
    </div>
  );
};
